// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__aXApQ","switch":"styles_switch__Ug9ib","label":"styles_label__sD8Ht"};